module.exports = __webpack_public_path__ + "static/media/diversity-hero.a70bb8ba.png";